import { useEffect, useState } from "react";
import Container from "~/components/layout/Container";
import { Icon } from "~/components/ui/icon";
import { slugify } from "~/lib/slugify";
import { HizmetListesi } from "../hizmetlerimiz+/_index";
import { MekanikTesisatListesi } from "../mekanik-tesisatlar+/_index";
import { Social } from "./Social";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
  }, []);
  const theme = 'light'
  return (
    <header className="flex flex-wrap fixed top-0 left-0 right-0 z-20 header">
      <div className="flex w-full bg-[#16437c] py-0">
        <Container className="flex items-start justify-between py-1">
          <div className="flex items-center w-2/3 md:w-11/12 font-raleway">
            <a href="mailto:bilgi@aldemuhendislik.com" className="text-sm font-lato mr-2 text-gray-100 hidden md:block"><Icon name="bxs:envelope" /> bilgi@aldemuhendislik.com</a>
            <a href="tel:+905443669808" className="text-sm text-gray-100 font-lato"><Icon name="material-symbols:phone-in-talk-watchface-indicator-sharp" /> +90 544 366 98 08</a>
          </div>
          <div className="w-13 md:w-1/12 flex items-start justify-end [&>a]:leading-[12px] [&>a]:text-gray-100">
            <Social />
          </div>
        </Container>
      </div>
      <div className="flex w-full justify-between mt-0 bg-gray-200/90">
        <Container className="flex items-start justify-between">
          <a href='/' className="logo hidden md:flex items-start z-30"><img src="/assets/AL-DE-muhendislik-logo.svg" alt="Al-De Mühendislik" className="h-[110px] w-[110px] p-1 my-1" /></a>
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden absolute right-2 top-[68px] focus:outline-none">
            <Icon name="material-symbols:menu" className="w-7 h-7 text-black" />
          </button>
          <a href='/' className="m-logo flex md:hidden items-start p-1 z-30"><img src="/assets/AL-DE-muhendislik-logo.svg" alt="Al-De Mühendislik" className="h-[80px] w-[80px]" /></a>
          <nav className={`${isOpen ? 'flex' : 'hidden'} ${NavStyle}`}>
            <a href='/' className="flex md:hidden items-center justify-center md:mt-[-50px]p-1 z-30"><img src="/assets/AL-DE-muhendislik-logo.svg" alt="Al-De Mühendislik" className="h-[120px] w-[120px]" /></a>
            <button onClick={() => setIsOpen(false)} className="md:hidden fixed right-8 top-2 focus:outline-none z-50 border-2">
              <Icon name="uil:times" className="w-7 h-7 text-black" />
            </button>
            <a href="/" className="hover:text-gray-800 text-gray-200 font-extrabold">ANASAYFA</a>
            <a href="/hakkimizda" className="hover:text-gray-800 text-gray-200">HAKKIMIZDA</a>
            <a href="/hizmetlerimiz" className="hover:text-gray-800 text-gray-200 group relative">HİZMETLERİMİZ
              {!isMobile && <ul className="!hidden md:!hidden group-hover:!block absolute left-0 top-full w-[230px] bg-gray-100 p-2 z-40">
                {HizmetListesi.map((service) => (
                  <li key={service.id}><a href={`/hizmetlerimiz/${slugify(service.title)}/${service.id}`} className="block w-full text-gray-900 hover:bg-gray-700 text-left hover:text-white p-2">{service.title}</a></li>
                ))}
              </ul>}
            </a>
            <a href="/mekanik-tesisatlar" className="hover:text-gray-800 text-gray-200 group relative">MEKANİK TESİSAT
              {!isMobile && <ul className="!hidden md:!hidden group-hover:!block absolute bg-gray-100 p-2 z-40 w-[230px]">
                {MekanikTesisatListesi.map((service) => (
                  <li key={service.id}><a href={`/mekanik-tesisatlar/${slugify(service.title)}/${service.id}`} className="block w-full text-gray-900 hover:bg-gray-700 text-left hover:text-white p-2">{service.title}</a></li>
                ))}
              </ul>}
            </a>
            <a href="/blog" className="hover:text-gray-800 text-gray-200">BLOG</a>
            <a href="/iletisim" className="hover:text-gray-800 text-gray-200">İLETİŞİM</a>
          </nav>
        </Container>
      </div>
    </header>
  );
}

const NavStyle = `nav w-full md:w-auto mt-12 h-[100vh] md:h-auto  md:flex flex-wrap md:flex-nowrap justify-around font-raleway font-bold text-[22px] md:text-[16px] bg-[#ffffffee] md:bg-transparent items-start absolute md:relative -top-12 md:!top-0 left-0 right-0 bottom-0 md:top-auto md:left-auto md:right-auto md:bottom-auto z-50 
[&>a]:text-center [&>a]:text-slate-800 [&>a]:py-6 [&>a]:md:pb-8 md:[&>a]:pb-0 [&>a]:border-b-1 [&>a]:border-b-gray-200 md:[&>a]:border-none [&>a]:w-full px-0 md:[&>a]:px-4 md:[&>a]:w-auto md:[&>a]:hover:text-red-800 `